// Remplacez cette valeur par votre véritable ID de mesure Google Analytics
// export const GA_MEASUREMENT_ID = 'G-6REHBCWLV8'
export const GA_MEASUREMENT_ID = 'GTM-KBDG47CV'

// Déclaration des types pour window.gtag
declare global {
  interface Window {
    gtag: (
      command: string,
      action: string | any,
      params?: {
        [key: string]: any
      },
    ) => void
    dataLayer: any[]
  }
}

// Fonction pour envoyer une page vue à Google Analytics
export const pageview = (url: string, title?: string, path?: string) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: path || url,
      page_title: title,
      page_location: window.location.origin + url,
    })

    // Log en développement pour faciliter le débogage
    if (process.env.NODE_ENV === "development") {
      console.log(`📊 Page vue: ${title || url}`)
    }
  }
}

// Fonction pour envoyer un événement à Google Analytics
export const event = ({
  action,
  category,
  label,
  value,
  ...rest
}: {
  action: string
  category: string
  label?: string
  value?: number
  [key: string]: any
}) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
      ...rest,
    })

    // Pour les événements de conversion importants, on peut également les envoyer comme des conversions
    if (category === "conversion") {
      window.gtag("event", "conversion", {
        send_to: GA_MEASUREMENT_ID,
        event_category: category,
        event_label: label,
        ...rest,
      })
    }

    // Enregistrer les métriques d'engagement pour l'analyse
    if (category === "engagement") {
      // Vous pouvez ajouter des paramètres spécifiques pour les événements d'engagement
      window.gtag("event", action, {
        event_category: category,
        event_label: label,
        value: value,
        non_interaction: action === "section_view" || action === "scroll_depth", // Ne pas compter comme une interaction utilisateur
        ...rest,
      })
    }

    // Log en développement pour faciliter le débogage
    if (process.env.NODE_ENV === "development") {
      console.log(`📊 Événement: ${action} - ${category} - ${label || ""}`)
    }
  }
}

// Fonction pour envoyer des données de session à Google Analytics
export const sendSessionData = (data: { [key: string]: any }) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("set", "user_properties", data)

    // Log en développement pour faciliter le débogage
    if (process.env.NODE_ENV === "development") {
      console.log(`📊 Données de session envoyées`, data)
    }
  }
}
